import { useCallback, useEffect, useState } from 'react';
import { useQueryNurseryMortality } from 'v2/resources/hooks/services/useGraphics';
import {
  useAppDispatch,
  useAppSelector,
} from 'v2/resources/hooks/useAppSelector';
import { IResponseNurseryMortality } from 'v2/resources/types/graphics';
import { setGraphicNurseryMortality } from 'v2/store/dataChat/slice';

const useNurseryMortality = () => {
  const dispatch = useAppDispatch();
  const { selectedCycle } = useAppSelector((state) => state.selectedCycle);
  const { data: dataNurseryMortality } = useQueryNurseryMortality(
    selectedCycle?.id
  );

  const [mortalityData, setMortalityData] = useState<
    IResponseNurseryMortality[]
  >([]);
  const [selectedShrimpPonds, setSelectedShrimpPonds] = useState<
    IResponseNurseryMortality[]
  >([]);

  const handleLoadData = useCallback(() => {
    if (!dataNurseryMortality) return;

    setSelectedShrimpPonds(dataNurseryMortality);
    setMortalityData(dataNurseryMortality);
    dispatch(setGraphicNurseryMortality(dataNurseryMortality));
  }, [dataNurseryMortality]);

  useEffect(() => {
    handleLoadData();
  }, [handleLoadData]);

  return {
    mortalityData,
    selectedShrimpPonds,
    setSelectedShrimpPonds,
  };
};

export default useNurseryMortality;
